var Store = {
	role: []
}

export { Store };